module.exports = __webpack_public_path__ + "resources/img/img_watchall_dbms01_jp.94a7eef13b798bbd3acf36b929ce89d5.png";